import * as React from 'react';
import { connect } from 'react-redux';

import { StateType } from '../../../reducers';
import {
  accountConfirmationSelector,
  accountErrorsConfirmationSelector,
  accountErrorsPasswordSelector,
  accountPasswordSelector,
} from '../../../reducers/AccountReducer/AccountSelector';

import { PasswordProps, PasswordStateProps } from './types';
import PasswordMain from './PasswordMain';

const Password = (props: PasswordProps & PasswordStateProps) => <PasswordMain {...props} />;

const mapStateToProps = (state: StateType): PasswordStateProps => ({
  passwordValue: accountPasswordSelector(state),
  passwordErrors: accountErrorsPasswordSelector(state),
  confirmPasswordValue: accountConfirmationSelector(state),
  confirmPasswordErrors: accountErrorsConfirmationSelector(state),
});

export default connect<PasswordStateProps, any, any, StateType>(mapStateToProps, null)(Password);
